import { FC } from 'react';
import IconEye from 'src/assets/images/icons/eye-colored.svg';
import { IButtonRowActionProps } from './types';
import { useInternalDashboardSelector } from './Selector';

export const ButtonRowAction: FC<IButtonRowActionProps> = (props) => {
  const { data, actionType } = props;
  const { runRowAction } = useInternalDashboardSelector();

  return (
    <button
      type='button'
      className='w-full flex items-center justify-center gap-4 text-14 font-medium text-primary'
      onClick={() => runRowAction(data, actionType)}
    >
      <span>See Details</span>
      <img src={IconEye} alt='' />
    </button>
  );
};
